enum CacheType{
    aviation_cache = "aviation_cache"
}

export default CacheType;